import PropTypes from 'prop-types';
import React from 'react';
import { lookerParams } from '../../../../../shared/lookerParams';
import OutputTab from '../OutputTab';

RevenueOpportunityTab.propTypes = {
    activeTab: PropTypes.string,
    onLoadComplete: PropTypes.func,
};

function RevenueOpportunityTab(props) {
    return (
        <OutputTab
            activeTab={props.activeTab}
            lookerTemplates={lookerParams.lookerPath.revenueOpportunityTab}
            onLoadComplete={props.onLoadComplete}
            tabLabel="RevenueOpportunity"
            includeChart
        />
    );
}

export default RevenueOpportunityTab;
